import React from "react";

import { Edit, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { CommoditiesForm } from '../forms/CreateEditForm';


export const CommoditiesEdit = ({permissions, ...props}) => (
	<Edit {...props} undoable={false}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
			<CommoditiesForm isEditForm />
		</SimpleForm>
	</Edit>
);
